// extracted by mini-css-extract-plugin
module.exports = {"portalpage":"PortalPage_portalpage__7v7xx"};